import {Component, Input, OnInit} from '@angular/core';
import {Product} from '../../interface/product';
import {PriceCalculationService} from '../../service/price-calculation.service';
import {CurrencyResolverService} from "../../../currency-resolver.service";
import {ApCurrency} from "../../../pipe/enum/ap-currency";

@Component({
	selector: 'fb-product-basic-info',
	templateUrl: './product-basic-info.component.html',
	styleUrls: ['./product-basic-info.component.scss']
})
export class ProductBasicInfoComponent implements OnInit {
	@Input() dataProductBasicInfo: Product = {} as Product;
	public price: number = 0;
	public undiscountedPrice: number = 0;
	public storediscountedPrice: number = 0;
	public selectedCurrency: ApCurrency = ApCurrency.INR;

	constructor(
		private _priceCalculation: PriceCalculationService,
		public _currencyResolver: CurrencyResolverService,
	) {

	}

	public ngOnInit(): void {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		this.price = this.dataProductBasicInfo.price;
		this._priceCalculation.observePrice.subscribe((data: number): void => {
			this.price = data;
			this.undiscountedPrice = this._priceCalculation.storeUndiscountedPrice;
			this.storediscountedPrice = this._priceCalculation.storediscountedPrice;
		});
		// console.log(this.dataProductBasicInfo)
	}
}
